import { useCallback, useEffect, useRef, useState } from 'react';

// TODO: there should be a common controller that will handle the uou and user case and then the isUoUChat wont be needed

export const useSyncCalendarPopup = _ref => {
  let {
    getCalendarOAuthUrl,
    onAuthSuccess,
    onAuthFailure
  } = _ref;
  const [currentProvider, setCurrentProvider] = useState(null);
  const authWindowRef = useRef(null);
  const onChooseProvider = async provider => {
    setCurrentProvider(provider);
    const url = await getCalendarOAuthUrl({
      provider
    });
    authWindowRef.current = window.open(url, 'authWindow', 'popup=true,width=600,height=700');
  };
  const closeAuthWindow = () => {
    if (authWindowRef.current) {
      authWindowRef.current.close();
    }
  };
  const handleMessage = useCallback(async event => {
    if (event.origin !== window.location.origin) {
      return;
    }
    if (event.data.type === 'authSuccess') {
      closeAuthWindow();
      onAuthSuccess && onAuthSuccess(currentProvider);
    }
    if (event.data.type === 'authFailure') {
      closeAuthWindow();
      console.log('failure');
      onAuthFailure && onAuthFailure(currentProvider);
    }
  }, [onAuthSuccess, currentProvider, onAuthFailure]);
  useEffect(() => {
    window.addEventListener('message', handleMessage);
    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, [handleMessage]);
  return {
    onChooseProvider
  };
};
//# sourceMappingURL=useSyncCalendarPopup.js.map